import { fetchUserRepo } from "../../repositories/user/user";
import { createSlice } from "@reduxjs/toolkit";
import Cookies from "universal-cookie";

const userSlice = createSlice({
  name: "userReducer",
  initialState: {
    loading: null,
    user: null,
    user_error: null,
  },
  reducers: {
    Loading(state, action) {
      return {
        ...state,
        medicalDegreeLoading: true,
      };
    },
    setUserInState(state, action) {
      return {
        ...state,
        loading: false,
        user: action.payload,
      };
    },
    tokenError(state, action) {
      return {
        ...state,
        loading: false,
        user: null,
        user_error: action.payload,
      };
    },
  },
});
export const { Loading, setUserInState, tokenError } = userSlice.actions;
export const fetchUser = (params) => {
  const cookies = new Cookies();
  let sessionKey = ''
  Object.keys(cookies.getAll())?.map((value, index) => {
    if (value?.includes("SESS") && !value?.includes("CSESS360"))
      sessionKey = value
  })

  const sessionValue = cookies.get(sessionKey)
  return async (dispatch) => {
    dispatch(Loading(false));
    await fetchUserRepo(sessionValue)
      .then((response) => {
        dispatch(setUserInState(response?.data));
      })
      .catch((error) => {
        dispatch(tokenError("User Not Authenticated"));
      });
  };
};

export default userSlice.reducer;
